import { mapGetters } from 'vuex'

export const authComputed = {
    ...mapGetters(['loggedIn', 'user', 'userSubscriptionInfo', 'canceledSubscription', 'allowCookies', 'planName', 'planHasPF'])
}
